<template>
  <div>
    <BaseButton @click="modalOpen = true">
      <template slot="iconLeft">
        <Icon
          view-box="0 0 24 24"
          class="w-5 h-5"
        >
          <Plus />
        </Icon>
      </template>
      Add members
    </BaseButton>

    <Modal
      :open="modalOpen"
      @close="modalOpen = false"
    >
      <div class="bg-white border-b-2">
        <div class="flex justify-between px-6 pb-6">
          <h3 class="text-lg font-medium">
            Add members
          </h3>
          <button
            class="text-gray-500 focus:outline-none"
            @click="close"
          >
            <Icon
              view-box="0 0 24 24"
              class="w-5 h-5 transform rotate-45"
            >
              <Plus />
            </Icon>
          </button>
        </div>
      </div>

      <AddTeamMemberForm
        @createdTeamMember="$emit('createdTeamMember')"
        @close="modalOpen = false"
      />
    </Modal>
  </div>
</template>

<script>
import Modal from '@components/Modal'
import AddTeamMemberForm from '@components/Teams/AddTeamMemberForm'
import Icon from '@components/Icons/Icon'
import Plus from '@components/Icons/Plus'

export default {
  components: {
    Modal,
    AddTeamMemberForm,
    Icon,
    Plus
  },

  data() {
    return {
      modalOpen: false
    }
  },

  methods: {
    close() {
      this.modalOpen = false
      this.$emit('close')
    }
  }
}
</script>
